import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/arrow.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-20422452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile cart" }
const _hoisted_2 = { class: "card profile-info full-height" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "back-icon"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, "Сообщения", -1))
const _hoisted_8 = {
  key: 0,
  class: "messages-container mt-4"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "product" }
const _hoisted_15 = { class: "price" }
const _hoisted_16 = { class: "message notranslate" }
const _hoisted_17 = { class: "date" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "chat-wrapper" }
const _hoisted_20 = { class: "icon" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "info" }
const _hoisted_23 = { class: "name" }
const _hoisted_24 = {
  key: 0,
  class: "product"
}
const _hoisted_25 = { class: "price" }
const _hoisted_26 = { class: "message" }
const _hoisted_27 = { class: "date" }
const _hoisted_28 = { class: "input" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "24",
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.75792 0.0190455C1.49222 -0.0241343 1.22021 0.00641404 0.969617 0.107578C0.719024 0.208742 0.498801 0.376905 0.33139 0.594932C0.16398 0.812959 0.0553641 1.07306 0.0166118 1.34872C-0.0221404 1.62439 0.0103559 1.90576 0.110789 2.16419L2.81274 9.10805C2.96407 9.49674 3.22418 9.82967 3.55963 10.064C3.89508 10.2984 4.29054 10.4235 4.69518 10.4233H12.6712C13.0747 10.4233 13.4617 10.5893 13.747 10.8848C14.0323 11.1803 14.1926 11.5811 14.1926 11.9991C14.1926 12.417 14.0323 12.8178 13.747 13.1133C13.4617 13.4088 13.0747 13.5748 12.6712 13.5748H4.69518C4.29088 13.575 3.89587 13.7003 3.56082 13.9347C3.22577 14.169 2.96597 14.5017 2.81477 14.8901L0.110789 21.8339C0.010012 22.0923 -0.0228282 22.3737 0.0156165 22.6494C0.0540612 22.9252 0.162416 23.1855 0.329635 23.4037C0.496854 23.622 0.716957 23.7904 0.967508 23.8919C1.21806 23.9933 1.4901 24.0241 1.75589 23.9812C10.4116 22.5854 18.5681 18.8819 25.4243 13.2345C25.6038 13.0869 25.7489 12.8993 25.8485 12.6855C25.9482 12.4718 26 12.2375 26 12.0001C26 11.7627 25.9482 11.5284 25.8485 11.3147C25.7489 11.101 25.6038 10.9133 25.4243 10.7658C18.5681 5.1183 10.4137 1.41484 1.75792 0.0190455Z",
    fill: "#3E3E3E"
  })
], -1))
const _hoisted_30 = [
  _hoisted_29
]

import chatRoom from '@/services/chatRoom';
  import { computed, onMounted, ref, watch, nextTick, onUnmounted } from 'vue';
  import moment from 'moment';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Messages',
  setup(__props) {

  const store = useStore();
  const rooms = ref<any[]>([]);
  const messages = ref<any[]>([]);
  const text = ref('');
  const socket = ref<WebSocket | null>(null);
  const messagesContainer = ref<HTMLElement | null>(null);
  const endOfMessages = ref<HTMLElement | null>(null);
  const router = useRouter();
  const websocketProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

  const createSocket = (path: string) => new WebSocket(`${websocketProtocol}://${window.location.host}${path}`);

  moment.locale('ru');

  onMounted(async () => {
    const rooms1 = await chatRoom.getAll();
    const rooms2 = await chatRoom.getFriendsAllChats();
    if (messages.value.length > 0) {
      scrollToBottom();
    }
    if (store.state.chats.selectId) {
      messages.value = await chatRoom.getRoom(store.state.chats.selectId);
      socket.value = createSocket('/ws/chat/' + store.state.chats.selectSlug + '/');
    } else {
      if (store.state.chats.selectSlug) {
        messages.value = await chatRoom.getFriendMessages(store.state.chats.selectSlug);
        socket.value = createSocket('/ws/chat-friend/' + store.state.chats.selectSlug + '/');
      }
    }
    rooms.value = [...rooms1, ...rooms2];
  });

  onUnmounted(() => {
    store.dispatch('chats/SelectChat', {
      selectId: null,
      selectSlug: '',
    });
  });

  watch(store.state.chats, async () => {
    if (store.state.chats.selectId && selectChat.value?.product) {
      messages.value = await chatRoom.getRoom(store.state.chats.selectId);
      socket.value = createSocket('/ws/chat/' + store.state.chats.selectSlug + '/');
    } else {
      if (store.state.chats.selectSlug) {
        messages.value = await chatRoom.getFriendMessages(store.state.chats.selectSlug);
        socket.value = createSocket('/ws/chat-friend/' + store.state.chats.selectSlug + '/');
      }
    }
  });

  watch(socket, () => {
    if (socket.value) {
      socket.value.onmessage = (event) => {
        messages.value.push(JSON.parse(event.data));
        scrollToBottom();
      };
    }
  });

  const selectChat = computed(() => {
    if (!rooms.value || rooms.value.length === 0) {
      return null;
    }
    return rooms.value.find((room) => room.slug == store.state.chats.selectSlug);
  });
  const goToProduct = (id: string) => {
    if (id) {
      router.push({
        name: 'MarketplaceItem',
        params: { id: id },
      });
    }
  };
  const selectRoom = async (room: { id: string; slug: string }) => {
    await store.dispatch('chats/SelectChat', {
      selectId: room.id,
      selectSlug: room.slug,
    });
    scrollToTop();
  };

  const sendMessage = () => {
    if (socket.value && socket.value.readyState === WebSocket.OPEN && text.value) {
      socket.value?.send(
        JSON.stringify({
          message: text.value,
          type: 'message',
          user: store.state.user.user.id,
        })
      );
      text.value = '';
      scrollToBottom();
    }
  };

  const closeRoom = () => {
    store.dispatch('chats/SelectChat', {
      selectId: null,
      selectSlug: '',
    });
  };

  // Функция для прокрутки чата вниз
  const scrollToBottom = () => {
    nextTick(() => {
      messagesContainer.value?.scrollTo({
        top: messagesContainer.value.scrollHeight,
        behavior: 'smooth',
      });
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  watch(messages, () => {
    scrollToBottom();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(store).state.chats.selectId || _unref(store).state.chats.selectSlug)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-link me-2",
                onClick: closeRoom
              }, _hoisted_6))
            : _createCommentVNode("", true),
          _hoisted_7
        ]),
        (!_unref(store).state.chats.selectId && !_unref(store).state.chats.selectSlug)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rooms.value, (room) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: room.slug,
                  class: "room flex-md-row flex-column align-items-start",
                  onClick: ($event: any) => (selectRoom(room))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: 
                  room?.product
                    ? room?.product.images[0].image
                    : room?.user2.avatar || require('@/assets/images/user-icon.png')
                ,
                      alt: ""
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(room?.product ? room?.user.full_name : room?.user2.full_name), 1),
                    _createElementVNode("p", _hoisted_14, [
                      _createTextVNode(_toDisplayString(room.product?.name) + " ", 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(room.product?.price), 1)
                    ]),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(room.last_message?.body || 'Нет сообщений'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(room.last_message && _unref(moment)(room.last_message?.sended_time).format('MMMM DD YYYY')), 1)
                ], 8, _hoisted_9))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: "room flex-md-row flex-column align-items-start py-4 px-4 mb-0",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToProduct(selectChat.value?.product.id)))
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("img", {
                      src: 
                    selectChat.value?.product
                      ? selectChat.value?.product.images[0].image
                      : selectChat.value?.user2.avatar || require('@/assets/images/user-icon.png')
                  ,
                      alt: ""
                    }, null, 8, _hoisted_21)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, _toDisplayString(selectChat.value?.product ? selectChat.value?.user.full_name : selectChat.value?.user2.full_name), 1),
                    (selectChat.value?.product)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                          _createTextVNode(_toDisplayString(selectChat.value?.product.name) + " ", 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(selectChat.value?.product.price), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_26, _toDisplayString(selectChat.value?.last_message?.body || 'Нет сообщений'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(selectChat.value?.last_message && _unref(moment)(selectChat.value?.last_message?.sended_time).format('MMMM DD YYYY')), 1)
                ]),
                _createElementVNode("div", {
                  ref_key: "messagesContainer",
                  ref: messagesContainer,
                  class: "wrapper-messages"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message.id,
                      class: _normalizeClass([
                  'message',
                  'notranslate',
                  {
                    owner: message.user === _unref(store).state.user.user.id || message.user.id === _unref(store).state.user.user.id,
                  },
                ]),
                      translate: "no"
                    }, _toDisplayString(message.body || message.message), 3))
                  }), 128)),
                  _createElementVNode("div", {
                    ref_key: "endOfMessages",
                    ref: endOfMessages
                  }, null, 512)
                ], 512),
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((text).value = $event)),
                    type: "text",
                    placeholder: "Напишите сообщение...",
                    translate: "no",
                    onKeydown: _withKeys(sendMessage, ["enter"])
                  }, null, 544), [
                    [_vModelText, text.value]
                  ]),
                  _createElementVNode("button", {
                    class: "send",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (sendMessage()))
                  }, _hoisted_30)
                ])
              ])
            ]))
      ])
    ])
  ]))
}
}

})